import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useResource } from '@axios-use/react';
import { isEmpty } from 'lodash';
import dayjs from 'dayjs';

import { LOGIN_UNIONPAY } from '@/constants/path';
import type { CouponInfoItem } from '@/apis/tiktok';
import { getUserCartListWithoutLoginReqConfig } from '@/apis/tiktok';
import { channelNavigateTo, isDouyinAppChannel } from '@/channels';
import useAppTitle from '@/hooks/useTitle';
import Spin from '../Product/external/Spin';

import './components/CommonCouponCard/index.less';
import './index.less';

const CouponItemCard = (props: { item?: CouponInfoItem; onClick?: () => void }) => {
  const { item, onClick } = props;

  const renderTime = () => {
    const startTrade = item?.startTime ? dayjs(item.startTime * 1000).format('YYYY.MM.DD') : undefined;
    const endTrade = item?.expireTime ? dayjs(item.expireTime * 1000).format('YYYY.MM.DD') : undefined;
    if (startTrade && endTrade) {
      return (
        <div
          className="common-coupon-date"
          style={{
            width: 'calc(100vw - 180Px)',
          }}>
          {`${startTrade}-${endTrade}`}
        </div>
      );
    }
  };
  return (
    <div className="common-coupon-index-outside" onClick={onClick}>
      <div className="common-coupon-index" style={{ width: 'calc(100vw - 40px)' }}>
        <div className="bg-coupon-pickup-yellow"></div>
        <div
          className="common-coupon-content"
          style={{
            background: '#fff',
          }}>
          <div className="common-coupon-content-top">
            {/*商品图*/}
            <div className={'coupon-group'}>
              <img className="common-coupon-content-img" src={item?.couponPreviewPath} />
            </div>

            {/*详情*/}
            <div className="common-coupon-content-text" style={{ marginLeft: '10px' }}>
              <div className="common-coupon-content-t">
                {/*标题*/}
                <div className="common-coupon-title" style={{ width: 'calc(100vw - 180Px)' }}>
                  {item?.productName}
                </div>
              </div>
              <div className="common-coupon-content-b">{renderTime()}</div>
            </div>
          </div>

          {/* 下划线 */}
          <div className={`coupon-divider`}>
            <div className="semi-circle-left" />
            <div className="dash-line" />
            <div className="semi-circle-right" />
          </div>

          <div className="common-coupon-content-bottom">
            <div />
            <div className="content-bottom-btn">
              <div className="content-bottom-use">立即使用</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const CardListWithoutLoginPage = () => {
  useAppTitle({
    title: '我的卡券',
    navBackgroundColor: 'FFFFFFFF',
    appletStyle: 'black',
    backBtnVisible: '1',
    appletTitleBarVisible: '1',
  });

  const [list] = useResource(getUserCartListWithoutLoginReqConfig, [{ page: 1, page_size: 50 }], {
    onCompleted(_, res) {
      console.info('获取卡券列表成功', res);
    },
    onError(err) {
      console.info('获取卡券列表失败', err);
    },
  });

  const navigate = useNavigate();
  const onLogin = useCallback(() => {
    if (isDouyinAppChannel()) {
      channelNavigateTo(`/pages/login/index`, {
        redirect: true,
      });
    } else {
      navigate(LOGIN_UNIONPAY);
    }
  }, [navigate]);

  return (
    <div style={{ padding: '16px 0' }}>
      <Spin loading={list.isLoading}>
        {isEmpty(list.data?.certificates) && (
          <div style={{ padding: '100px 0', textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>
            您还没有卡券
          </div>
        )}
        {list.data?.certificates?.map(
          (item, index) =>
            item.couponCode && <CouponItemCard key={`${item.couponCode}${index}`} item={item} onClick={onLogin} />,
        )}
      </Spin>
    </div>
  );
};
export default CardListWithoutLoginPage;
